import {FC, useCallback} from 'react';

import {Box} from '@mui/material';

import InfoIconLight from 'assets/icons/infoIcon';
import InfoIcon from 'assets/icons/infoIcon';
import useAnalytics from 'contexts/analytics-context';
import SendBrowserEvent from 'services/send-browser-event';
import {EstimatedPointsDetails, LoyaltyEvent} from 'types';

interface EstimatedPointsIconProps {
  iconVariant?: 'dark' | 'light';
  estimatedPointsDetails: EstimatedPointsDetails[];
}

export const EstimatePointsIcon: FC<EstimatedPointsIconProps> = (props: EstimatedPointsIconProps) => {
  const {iconVariant = 'dark', estimatedPointsDetails} = props;
  const analytics = useAnalytics();

  const onOpen = useCallback(() => {
    SendBrowserEvent.toggleProPointsEstimation(estimatedPointsDetails);
    analytics.trackPageView(LoyaltyEvent.PRO_POINT_ESTIMATE, {});
  }, [analytics, estimatedPointsDetails]);

  return (
    <Box display="flex" onMouseOver={onOpen}>
      {iconVariant === 'dark' && <InfoIcon fontSize={'small'} />}
      {iconVariant === 'light' && <InfoIconLight />}
    </Box>
  );
};
